export default __webpack_public_path__ + "static/usb_c_xr_charging_adapter-679ca3e4a9fc11b608f2265e293549ab.png";